export function MiniIcon(props: React.HTMLAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 132.292 58.029"
      aria-hidden="true"
      {...props}
    >
      <path
        opacity={1}
        fill="#120a08"
        fillOpacity={1}
        stroke="none"
        strokeWidth={1.68198478}
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit={4}
        strokeDasharray="none"
        strokeDashoffset={0}
        strokeOpacity={1}
        paintOrder="markers stroke fill"
        d="M88.725 154.442a29.005 29.005 0 0 0-24.445 13.402h-41.7l4.151 4.151h35.383a29.005 29.005 0 0 0-1.593 4.836H31.568l4.1 4.101H59.85a29.005 29.005 0 0 0-.129 2.515 29.005 29.005 0 0 0 .116 2.322H40.505l4.1 4.1h15.863a29.005 29.005 0 0 0 1.53 4.837H49.442l4.152 4.152h10.6a29.005 29.005 0 0 0 24.531 13.593 29.005 29.005 0 0 0 24.531-13.593h10.602l4.15-4.152h-12.554a29.005 29.005 0 0 0 1.53-4.836h15.861l4.101-4.1h-19.332a29.005 29.005 0 0 0 .116-2.323 29.005 29.005 0 0 0-.128-2.515h24.18l4.102-4.1H116.93a29.005 29.005 0 0 0-1.593-4.837h35.383l4.151-4.151h-41.7a29.005 29.005 0 0 0-24.446-13.402Zm0 3.931a25.073 25.073 0 0 1 25.074 25.074 25.073 25.073 0 0 1-25.074 25.073 25.073 25.073 0 0 1-25.073-25.073 25.073 25.073 0 0 1 25.073-25.074ZM68.78 176.948v12.997h2.71v-10.23l2.86 10.23h2.81l2.868-10.23v10.23h2.71v-12.997h-4.376l-2.593 8.866-2.622-8.866zm16.787 0v12.997h2.918v-12.997zm5.717 0v12.997h2.711v-8.475l5.826 8.475h2.928v-12.997h-2.711v8.68l-5.914-8.68zm14.47 0v12.997h2.919v-12.997z"
        transform="translate(-22.58 -154.432)"
      />
    </svg>
  )
}
